/* Shared activation lifecycle for hosted players and the packaged Samsung shell. */
(function (root) {
  "use strict";
  root.FlexTechActivationSession = function (options) {
    var activation = options.activation;
    var stopped = false, busy = false, timer, failures = 0;
    var wallStart, monotonicStart, lifetime, requestTimer;
    function monotonic() { return root.performance ? root.performance.now() : Date.now(); }
    function resetClock(payload) {
      wallStart = Date.now();
      monotonicStart = monotonic();
      lifetime = Math.max(0, Date.parse(payload.expires_at) - Date.parse(payload.server_time || new Date().toISOString()));
    }
    function remaining() {
      return Math.max(0, Math.ceil((lifetime - Math.max(Date.now() - wallStart, monotonic() - monotonicStart)) / 1000));
    }
    function display(message) {
      if (!stopped) options.onChange(activation, remaining(), message || "");
    }
    function schedule(delay) {
      clearTimeout(timer);
      if (!stopped) timer = setTimeout(check, delay);
    }
    function check() {
      if (stopped || busy) return;
      clearTimeout(timer);
      busy = true;
      var expired = remaining() === 0;
      if (expired) display("Refreshing activation code…");
      var request = new Promise(function (resolve, reject) {
        requestTimer = setTimeout(function () { reject(new Error("Activation request timed out")); }, 20000);
        Promise.resolve().then(function () {
          return expired ? options.renew(activation.poll_token) : options.poll(activation.poll_token);
        }).then(resolve, reject);
      });
      request.then(function (payload) {
        clearTimeout(requestTimer);
        if (stopped) return;
        failures = 0;
        if (payload.status === "active") {
          stop();
          options.onActive(payload);
          return;
        }
        if (payload.expires_at) {
          var nextActivation = {};
          Object.keys(activation).forEach(function (key) { nextActivation[key] = activation[key]; });
          Object.keys(payload).forEach(function (key) { nextActivation[key] = payload[key]; });
          activation = nextActivation;
          resetClock(payload);
        }
        display();
        schedule(Math.min(4000, Math.max(250, remaining() * 1000)));
      }).catch(function (error) {
        clearTimeout(requestTimer);
        if (stopped) return;
        if (error.status === 410) {
          lifetime = 0;
          display("Refreshing activation code…");
          schedule(0);
        } else if (error.status === 401 || error.status === 403) {
          stop();
          options.onFatal(error);
        } else {
          failures += 1;
          display("Reconnecting to get a valid activation code…");
          schedule(Math.min(30000, 1000 * Math.pow(2, Math.min(failures - 1, 5))));
        }
      }).then(function () { busy = false; });
    }
    function wake() {
      display();
      check();
    }
    function visible() { if (!root.document.hidden) wake(); }
    function stop() {
      stopped = true;
      clearTimeout(timer);
      clearInterval(ticker);
      clearTimeout(requestTimer);
      root.removeEventListener("online", wake);
      root.removeEventListener("pageshow", wake);
      root.document.removeEventListener("visibilitychange", visible);
    }
    resetClock(activation);
    var ticker = setInterval(function () {
      display(failures ? "Reconnecting to get a valid activation code…" : remaining() === 0 ? "Refreshing activation code…" : "");
      // The scheduled check handles renewal and backoff.
    }, 1000);
    root.addEventListener("online", wake);
    root.addEventListener("pageshow", wake);
    root.document.addEventListener("visibilitychange", visible);
    display();
    schedule(Math.min(4000, remaining() * 1000));
    return { stop: stop, check: wake };
  };
})(typeof window !== "undefined" ? window : globalThis);
